module.exports = __webpack_public_path__ + "img/by@2x.9369689d.png";